export enum AppModesEnum {
    Photo = 'Photo',
    Video = 'Video',
    Map = 'Map',
    Chat = 'Chat',
    Telephone = 'Telephone'
}
